import React from "react";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex";
import LocationForm from "../LocationForm/LocationForm";
import { Location, ProjectVariable } from "../types/Location";

const FORM_ID = "location-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  locations: Location[];
  projectVariableDefinitions: ProjectVariable[];
}

const New: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  locations,
  projectVariableDefinitions,
}) => {
  const navigate = useNavigate();
  const canSave =
    (permission === "create" || permission === "manage") &&
    projectStatus === "building";

  return (
    <AdminFormPage
      title="Add Location"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${projectId}/project_locations`, {
          state: null,
        })
      }
    >
      <LocationForm
        formId={FORM_ID}
        projectId={projectId}
        locations={locations}
        projectVariableDefinitions={projectVariableDefinitions}
      />
    </AdminFormPage>
  );
};

export default New;
